import { Link } from "react-router-dom";

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20vibrant%20artistic%20abstract%20composition%20inspired%20by%20manga%20and%20comic%20art%2C%20flowing%20ink%20textures%20in%20coral%20orange%20and%20warm%20amber%20tones%2C%20soft%20gradient%20background%20with%20subtle%20Japanese%20wave%20patterns%2C%20modern%20minimalist%20aesthetic%2C%20warm%20atmospheric%20lighting%2C%20no%20text%2C%20no%20people&width=1600&height=800&seq=hero-bg-main&orientation=landscape"
        alt="番茄漫画 - 免费漫画阅读平台"
        title="番茄漫画免费漫画在线阅读"
        className="w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
        <div className="w-full max-w-3xl">
          <h1 className="text-3xl md:text-5xl font-bold text-background-50 mb-4 font-heading">
            番茄漫画 - 免费漫画全集大全
          </h1>
          <p className="text-base md:text-lg text-background-50/85 mb-8 max-w-xl mx-auto leading-relaxed">
            完结连载热门韩漫、日漫、国漫高清免费在线阅读，追更最新话，支持离线下载缓存，海量漫画免费看
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/all"
              className="px-6 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 cursor-pointer transition-colors whitespace-nowrap"
            >
              <i className="ri-book-open-line mr-2"></i>开始阅读
            </Link>
            <Link
              to="/category/completed"
              className="px-6 py-3 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 font-semibold text-sm border border-background-50/30 hover:bg-background-50/30 cursor-pointer transition-colors whitespace-nowrap"
            >
              <i className="ri-check-double-line mr-2"></i>完结漫画
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}